import AuthLayout from '../pages/AuthLayout.vue';
import DefaultLayout from '../pages/DefaultLayout.vue';
import LoginView from '../pages/Login.vue';
import Partners from '../pages/Partners.vue';
import TripCreateRequest from '../pages/TripCreateRequest.vue';
import VehicleRequest from '../pages/VehicleRequest.vue';
import TripRequest from '../pages/TripRequest.vue';
import BackupRequest from '../pages/BackupRequest.vue';
import TripRequestForm from '../pages/TripRequestForm.vue';
// import NotFound from '../pages/NotFound.vue';
import AssignedPartners from '../components/assignList/AssignedPartners';
import InServicePartners from '../components/assignList/InServicePartners';
import DisbursementView from '../components/disbursement/DisbursementView';
import accessDenied from '../pages/access-denied';
import customPermissionList from '../pages/CustomPermissionList';
import PartnerAttendance from '../pages/PartnerAttendance';
import partnerGasBill from '../components/gasBill/GasBill';
import partnerBill from '../pages/PartnerBill';
import PartnerDisburseViewDetails from '../pages/PartnerDisburseViewDetails';
import PartnerLocationList from '../pages/PartnerLocationList';
import PartnerProfile from '../pages/PartnerProfile';
import Permission from '../pages/Permission';
import CallNotesSettings from '../pages/settings/CallNotes';
import CarBrandSettings from '../pages/settings/CarBrand';
import CarTypeSettings from '../pages/settings/CarType';
import AreaSettings from '../pages/settings/location/Area';
import CitySettings from '../pages/settings/location/City';
import PresetRemarksSettings from '../pages/settings/PresetRemarks';
import PromoBannerSettings from '../pages/settings/PromoBanner';
import PromotionalVideoSettings from '../pages/settings/PromotionalVideo';
import EmailTemplateSettings from '../pages/settings/EmailTemplate';
import TripTypeSettings from '../pages/settings/TripType';
import HolidayCalendarSettings from '../pages/settings/HolidayCalendar';
import TripPercentageSettings from '../pages/settings/TripPercentage';
import TripDistanceSettings from '../pages/settings/DistanceList.vue';
import TripTimeSettings from '../pages/settings/TripTime.vue';
import TripCancelHideSettings from '../pages/settings/CancelHide.vue';
import TripDetails from '../pages/TripDetails.vue';
import BackupDetails from '../pages/BackupDetails.vue';
import VehicleRequestDetails from '../components/tripDetails/VehicleRequestDetails';
// import authentication from '../middleware/authenticate';
import Dashboard from '../pages/Dashboard.vue';

const routes = [
  {
    path: '/',
    redirect: '/',
    name: 'login',
    component: AuthLayout,
    meta: { isGuest: true },
    children: [{ path: '/', name: 'login', component: LoginView }]
  },
  {
    path: '/trip-create',
    redirect: '/trip-request/trip/create',
    component: DefaultLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '/dashboard',
        // redirect: "/dashboard",
        name: 'dashboard',
        component: Dashboard,
        meta: { requiresAuth: true }
      },
      {
        name: 'trip-request',
        path: '/trip-request',
        meta: {
          requiresAuth: true
        }
      },

      {
        name: 'access-denied',
        path: '/access-denied',
        component: accessDenied,
        meta: {
          requiresAuth: false
        }
      },
      {
        name: 'partners',
        path: '/trip-request/partners',
        component: Partners,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'vehicle-request',
        path: '/trip-request/vehicle/requests/:per_page?/:page_number?/:filter_data?',
        component: VehicleRequest,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'vehicle-request-details-id',
        path: '/trip-request/vehicle-request/details/:trip_request_id/:route_id?',
        component: VehicleRequestDetails,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'trip-request',
        path: '/trip-request/trip/requests',
        component: TripRequest,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'backup-request',
        path: '/trip-request/backup/requests',
        component: BackupRequest,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'trip-create',
        path: '/trip-request/trip/create',
        component: TripCreateRequest,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'trip-map-show',
        path: '/trip-request/trip/create/map_show',
        component: TripCreateRequest,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'trip-create-external',
        path: '/trip-request/trip/create/:token/:service_type/:action/:route_id?',
        component: TripCreateRequest,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'trip-request-form',
        path: '/trip-request/create/trip/request',
        component: TripRequestForm,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'trip-details-id',
        path: '/trip-request/trip/details/:id',
        component: TripDetails,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'partners-profile-id',
        path: '/trip-request/partners/profile/:id',
        component: PartnerProfile,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'service-partners',
        path: '/trip-request/service-partners',
        component: InServicePartners,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'assigned-partners',
        path: '/trip-request/assigned-partners',
        component: AssignedPartners,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'partners-attendance',
        path: '/trip-request/partners-attendance',
        component: PartnerAttendance,
        meta: {
          requiresAuth: true
        }
      },

      {
        name: 'partner-location-list',
        path: '/trip-request/partner-location-list',
        component: PartnerLocationList,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'partner-permission-list',
        path: '/trip-request/partner/permission/list',
        component: Permission,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'partner-custom-permission-list',
        path: '/trip-request/partner/custom/permission/list',
        component: customPermissionList,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'partners-gas-bill-view',
        path: '/trip-request/partners/gas-bill/view',
        component: partnerGasBill,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'partners-bill-view',
        path: '/trip-request/partners/bill/view',
        component: partnerBill,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'partners-disbursement-view',
        path: '/trip-request/partners/disbursement/view/:date?',
        component: DisbursementView,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'partners-disbursement-view-details',
        path: '/trip-request/partners/disbursement/view/details/:date/:serviceType',
        component: PartnerDisburseViewDetails,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'city-settings',
        path: '/settings/city',
        component: CitySettings,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'area-settings',
        path: '/settings/area',
        component: AreaSettings,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'car-type-settings',
        path: '/settings/car/type',
        component: CarTypeSettings,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'car-brand-settings',
        path: '/settings/car/brand',
        component: CarBrandSettings,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'trip-type-settings',
        path: '/settings/trip/type',
        component: TripTypeSettings,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'preset-remarks-settings',
        path: '/settings/preset-remarks',
        component: PresetRemarksSettings,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'call-notes-settings',
        path: '/settings/call-notes',
        component: CallNotesSettings,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'promo-banner-settings',
        path: '/settings/promo-banner',
        component: PromoBannerSettings,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'promotional-video-settings',
        path: '/settings/promotional-video',
        component: PromotionalVideoSettings,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'email-template-settings',
        path: '/settings/email-template',
        component: EmailTemplateSettings,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'backup-details-id',
        path: '/trip-request/backup/details/:id/:route_id',
        component: BackupDetails,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'holiday-calendar-settings',
        path: '/settings/holiday-calendar',
        component: HolidayCalendarSettings,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'trip-percentage-settings',
        path: '/settings/trip-percentage',
        component: TripPercentageSettings,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'distance-settings',
        path: '/settings/distance',
        component: TripDistanceSettings,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'time-settings',
        path: '/settings/time',
        component: TripTimeSettings,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'cancel-hide-settings',
        path: '/settings/cancel/hide',
        component: TripCancelHideSettings,
        meta: {
          requiresAuth: true
        }
      }
    ]
  }
];

export default routes;
